import workspace from "../../workspace";
import COLOR_THEMES, {COLOR} from "../../../store/colorThemes";
import sqftConfig from "../../../store/sqftConfig";
import {
  CABINET_FILTER_NAMES,
  RENDER_TEMPLATES,
  SIDEBAR_BUTTONS_MENU, SIDEBAR_NAVIGATION_BUTTONS,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS, SQFT_FEATURES
} from "../../../../../constants";
import config from "../../../store/sqftConfig";
import sqftShapeManager from "../../../store/sqftShapeManager";
import RenderParts from "../../../helpers/renderParts";
import RenderFigures from "../../../helpers/renderFigures";
import store from "../../../../../../../store";
import RenderCabinets from "../../../helpers/renderCabinets";
import {COLORS} from "../../../../../../../colorThemes";
import Config from "../../../../../../../config";
import {
  canShapeBeAutoShifted,
  getIsShapePlacedOnTheFloor,
  getIsShapePlacedOnTheWall
} from "../../../../../helpers/shapeHelper";
import {getPointField} from "../../../../../helpers/sqftHelper";
import {getQtCatName} from "../../../../../helpers/sqftQuotesHelper";
import * as uuid from "uuid";
import workspaceControllers from "../../../store/workspaceControllers";
import {getCurrentLayout} from "../../../../../../appLayout";
import {HingesModel} from "../../../store/models/HingesModel";
import {getHandleFeatureGroupFromShape} from "../../../../../helpers/sqftHelperUi";

class ShapeCabinet {
  __shape;
  __crownMoldingFeatureId = null;
  //__attachedFeatures = new Map();
  __crownMoldingParams = {
    distance: 10
  }

  constructor(shape) {
    this.__shape = shape;
  }

  import = (data) => {
    void data;
    // if (data.attachedFeatures) {
    //   const parsedFeatures = JSON.parse(data.attachedFeatures);
    //   this.__attachedFeatures = new Map(Object.entries(parsedFeatures));
    // }
  }

  export = () => {
    return {
      width: this.getShapeWidth(),
      height: this.getShapeHeight(),
      depth: this.getShapeDepth(),
      //attachedFeatures: JSON.stringify(Object.fromEntries(this.__attachedFeatures)),
    }
  }

  /**
   * create hinges and handles
   */
  generateAttachedFeatures = (generatedFeatures = Object.values(CABINET_FILTER_NAMES)) => {
    const filtersToProcess = generatedFeatures;
    const { filterGroups } = store.getState().filterState;
    const feature = this.__shape.getFeature();

    if (feature) {
      // Loop through each filter defined in CABINET_FILTER_NAMES.
      for (const key in CABINET_FILTER_NAMES) {
        const filterKey = CABINET_FILTER_NAMES[key];
        // Process only if the current filter is in the list of filters to process.
        if (!filtersToProcess.includes(filterKey)) {
          continue;
        }
        // Retrieve the quantity for this filter.
        const quantity = +feature.getFeatureSavedFilterName(filterGroups, filterKey, filterKey);

        if (quantity) {
          // Process hinges feature.
          if (filterKey === CABINET_FILTER_NAMES.hinges) {
            const layout = getCurrentLayout();
            const hingesFeatureGroup = layout.getFeatureGroupByPartId(SQFT_FEATURES.hinge);
            if (hingesFeatureGroup) {
              // Choose active feature if available, otherwise use the first one.
              const handlesFeature = hingesFeatureGroup.activeFeature || hingesFeatureGroup.features[0];
              workspaceControllers.hinge.addResource(new HingesModel(
                this.__shape.id,
                handlesFeature.dbFeature.id,
                getQtCatName(),
                uuid.v4(),
                hingesFeatureGroup.partId,
                quantity
              ));
            }
          }

          // Process knobs feature.
          if (filterKey === CABINET_FILTER_NAMES.knobs) {
            const handlesFeatureGroup = getHandleFeatureGroupFromShape(this.__shape);
            if (handlesFeatureGroup) {
              const reduxState = store.getState();
              const selectedHandle = reduxState.sqftResourceState.selectedHandle;
              let handlesFeature;

              if (selectedHandle) {
                handlesFeature = handlesFeatureGroup.features.find(feature =>
                  feature.getFeatureName() === selectedHandle.getFeatureName()
                );
                if (!handlesFeature) {
                  console.log(feature.getFeatureName() + " feature was not found is the featureGroup:" + handlesFeatureGroup.partName);
                }
              } else {
                handlesFeature = handlesFeatureGroup.features.find(feature =>
                  feature.dbFeature &&
                  Array.isArray(feature.dbFeature.thirdPartyAR3DUrls) &&
                  feature.dbFeature.thirdPartyAR3DUrls.length > 0
                );
              }

              if (handlesFeature) {
                workspaceControllers.handles.addHandleToTheShape(this.__shape, handlesFeature);
              }
            }
          }
        }
      }
    }
  };

  // Function to delete attached features based on an optional array of filter values.
  // If the parameter is not provided, resources for all filters will be deleted.
  deleteAttachedFeatures = (deletedFeatures = Object.values(CABINET_FILTER_NAMES)) => {
    const filtersToDelete = deletedFeatures;

    // Delete hinges
    if (filtersToDelete.includes(CABINET_FILTER_NAMES.hinges)) {
      workspaceControllers.hinge.deleteAllResourcesForTheShape(this.__shape.id);
    }

    // Delete knobs
    if (filtersToDelete.includes(CABINET_FILTER_NAMES.knobs)) {
      workspaceControllers.handles.deleteAllResourcesForTheShape(this.__shape.id);
    }
  };

   getShapeWidth = () => {
     return this.__shape.getWidth(true);
  }

  getShapeDepth = () => {
    return this.__shape.getDepth(true);
  }

  getShapeHeight = () => {
    return this.__shape.getHeight(true);
  }

  addCrownMolding = () => {
    const state = store.getState();
    const selectedFeature = state.sqftResourceState.selectedFeature;
    this.__crownMoldingFeatureId = selectedFeature ? selectedFeature.part.dbFeature.id : null
    console.log("this.__crownMoldingFeatureId", this.__crownMoldingFeatureId);
  }

  render = (ctx, staticOffset = null, template= RENDER_TEMPLATES.default) => {
    if (workspace && workspace.getState().loading) return;

    const fillTemplate = this.getFillColor(ctx);
    this.renderBorders(ctx, staticOffset, template, fillTemplate);
    this.renderDimensionsInsideShape(ctx);
    RenderParts.drawShapeCrownMoldings(ctx, staticOffset, this.__shape);
    RenderParts.drawShapeEndCap(ctx, staticOffset, this.__shape);
    this.renderHandles(ctx);
    //if (!this.__shape.shapeAbsolute.getAbsolutePosition() && !this.__shape.shapeAbsolute.getSnappedWithShape()) {
    if (this.__shape.shapeAbsolute.getSnappedShapeGroup() === null) {
      //this.renderCrownMolding(ctx);
      this.renderDimensionsOutsideShape(ctx);
    }
    if (Config.isDevMode()) {
      this.renderTestShapeLines(ctx, staticOffset, template);
      this.renderShapeSnappedGroup(ctx, staticOffset, template);
    }
  }

  renderMeasurementArrows = (ctx) => {
    const points = this.__shape.getPointsPointField();
    RenderFigures.drawArrowsAroundPoints(ctx, points, 10);
  }

  renderTestShapeLines = (ctx) => {
    if (this.__shape.testShapeLines) {
      ctx.save();
      ctx.beginPath();
      ctx.lineWidth = 2;
      ctx.strokeStyle = COLORS.gray;
      for (const testShapeLine of this.__shape.testShapeLines) {
        ctx.moveTo(testShapeLine.from.x, testShapeLine.from.y);
        ctx.lineTo(testShapeLine.to.x, testShapeLine.to.y);
      }
      ctx.stroke();
      ctx.closePath();
      ctx.restore();
    }
  }

  renderShapeSnappedGroup = (ctx) => {
    // render shape group
    let shapeCenter = this.__shape.getCenter();
    const pos = getPointField(shapeCenter.x, shapeCenter.y, this.__shape);
    const renderText = this.__shape.shapeAbsolute.getSnappedShapeGroup() + ".gr";
    const mText = ctx.measureText(renderText);
    ctx.wrapText(renderText, pos.x, pos.y, mText, 22);
  }

  renderMeasurementLength = (ctx) => {
    const points = this.__shape.getPointsPointField();
    RenderParts.drawMeasurementAroundPoints(ctx, points);
  }

  renderDimensionsOutsideShape = (ctx) => {
    ctx.save();
    ctx.beginPath();
    this.renderMeasurementArrows(ctx);
    this.renderMeasurementLength(ctx);
    ctx.closePath();
    ctx.restore();
  }

  renderDimensionsInsideShape = (ctx) => {
    const shapeWidth = this.getShapeWidth();
    const shapeHeight = this.getShapeHeight();
    const textWidth = 'W: ' + shapeWidth;
    const textHeight = 'H: ' + shapeHeight;
    const fontSize = config.workspace.fontSizeSmallest;// * config.scale / config.defaultScale;
    const font = fontSize + "px " + config.activeFontRegular;
    const mTextWidth = ctx.measureText(textWidth);
    const mTextHeight = ctx.measureText(textWidth);
    const {minX, maxX, minY, maxY} = sqftShapeManager.getMinMaxShapePoints(this.__shape,true, true);
    void minY;
    //middle of the bottom line
    let pos = {
      x: minX + (maxX - minX) / 2 - mTextWidth.width / 2,
      y: maxY - fontSize
    };

    // center position
    // let shapeCenter = ShapeHelper.getCenterPoint(points);
    // let shapeCenterOnField =  getPointField(shapeCenter.x, shapeCenter.y, this.__shape);
    // let pos = {
    //   x: shapeCenterOnField.x - mTextWidth.width / 2,
    //   y: shapeCenterOnField.y
    // };

    ctx.textAlign = "start";
    ctx.fillStyle = COLOR_THEMES[sqftConfig.activeTheme].primary_hover;

    const lineHeight = config.workspace.fontSizeSmallest;
    ctx.wrapText(textWidth, pos.x, pos.y - (fontSize / 2), mTextWidth, lineHeight, font);
    ctx.wrapText(textHeight, pos.x + 2, pos.y + (fontSize / 2), mTextHeight, lineHeight, font);
  }

  getFillColor = () => {
    // highlight shape on eyeball click
    if (this.__shape.shapeRender.blink.isHighlightedLightOn) {
      return RENDER_TEMPLATES.filledActive;
    } else {
      return RENDER_TEMPLATES.filledPrimary;
    }
  }

  renderBorders = (ctx,
                   staticOffset = null,
                   strokeTemplate= RENDER_TEMPLATES.default,
                   fillTemplate = RENDER_TEMPLATES.filledPrimary
  ) => {
    RenderParts.drawShapeBorders(ctx, staticOffset, strokeTemplate, fillTemplate, this.__shape);
    const reduxState = store.getState();
    const activeButton = reduxState.sqftMenuState.activeButton;
    if (activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.handles
      || activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.spacer
      || activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.crown
      || activeButton === SIDEBAR_NAVIGATION_BUTTONS.end_cap
      || activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.end_panel
      || activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.resize
      || activeButton === SIDEBAR_BUTTONS_MENU.delete
    ) {
      RenderParts.drawHoveredBorders(ctx, staticOffset, this.__shape);

    // Highlight possibility to insert shape between lines
    } else if (activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.upper
      || activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.lower
      || activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.tall
      || workspace.getMovingShape()
    ) {
      const movingShape = workspace.getMovingShape();
      const isTestShapePlacedOnTheFloor = getIsShapePlacedOnTheFloor(this.__shape);
      const isTestShapePlacedOnTheWall = getIsShapePlacedOnTheWall(this.__shape);
      //1. Highlight moving shape if their part ids are equal
      //2. Highlight upper shapes if we are dragging new upper cabinet shape
      //3. Highlight lower shapes if we are dragging new lower cabinet shape
      //4. Highlight lower shapes if we are dragging new tall cabinet shape
      if ((movingShape && canShapeBeAutoShifted(workspace.getMovingShape(), this.__shape))
        || (activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.upper && isTestShapePlacedOnTheWall)
        || (activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.lower && isTestShapePlacedOnTheFloor)
        || (activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.tall && isTestShapePlacedOnTheFloor)
      ) {
        const style = {
          lineWidth: 4,
          strokeStyle: COLOR.red,
          shadowBlur: 2,
          extendHoveredLine: 5
        };
        RenderParts.drawHoveredBorders(ctx, staticOffset, this.__shape, style);
      }
    }
  };

  renderHandles = (ctx) => {
    RenderParts.drawHandles(ctx, this.__shape)
  };

  getCrownMoldingPoints = () => {
    const points = this.__shape.getPointsPointField();

    return RenderCabinets.getDiagonalPointsForTheSquare(points, this.__crownMoldingParams.distance)
  }

  // renderCrownMolding = (ctx) => {
  //   if (this.__crownMoldingFeatureId) {
  //     const crownMoldingPoints = this.getCrownMoldingPoints();
  //     RenderCabinets.renderCrownMolding(ctx, crownMoldingPoints);
  //   }
  // };
}

export default ShapeCabinet
